const VERSION_STORAGE_KEY = 'version';
const VERSION_CHECK_AT_KEY = 'versionCheckedAt';

/** Повторный запрос check_version.php не чаще раза в 30 минут. */
const VERSION_POLL_INTERVAL_MS = 30 * 60 * 1000;

const reloadWithCacheBust = () => {
    if ('URL' in window) {
        const url = new URL(window.location.href);
        url.searchParams.set('reloadTime', Date.now().toString());
        window.location.href = url.toString();
        return;
    }

    const { origin, pathname, search, hash } = window.location;
    const separator = search ? '&' : '?';
    window.location.href =
        origin + pathname + search + separator + 'reloadTime=' + Date.now() + hash;
};

export const cleanReloadTimeParam = () => {
    if (!window.location.href.includes('reloadTime')) {
        return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('reloadTime');
    window.location.href = url.toString();
};

export const getStoredAppVersion = () => {
    const value = parseInt(window.localStorage.getItem(VERSION_STORAGE_KEY), 10);

    return Number.isFinite(value) ? value : null;
};

/**
 * Сравнивает версию с сохранённой; при изменении перезагружает страницу.
 * @param {string|number} serverVersion
 */
export const applyAppVersion = (serverVersion) => {
    const next = parseInt(serverVersion, 10);

    if (!Number.isFinite(next)) {
        return;
    }

    const prev = getStoredAppVersion();
    window.localStorage.setItem(VERSION_STORAGE_KEY, String(next));

    if (prev !== null && prev !== next) {
        reloadWithCacheBust();
        return;
    }

    cleanReloadTimeParam();
};

/**
 * Читает X-App-Version из ответа axios/fetch (без отдельного запроса).
 * @param {import('axios').AxiosResponse|Response} response
 */
export const handleAppVersionFromResponse = (response) => {
    const headers = response?.headers;

    if (!headers) {
        return;
    }

    const raw =
        headers['x-app-version'] ??
        headers['X-App-Version'] ??
        (typeof headers.get === 'function' ? headers.get('X-App-Version') : null);

    if (raw != null && raw !== '') {
        applyAppVersion(raw);
    }
};

/**
 * Явная проверка check_version.php — только при старте или раз в VERSION_POLL_INTERVAL_MS.
 * @param {string} baseUrl
 */
export const checkAppVersionIfStale = async (baseUrl) => {
    const lastCheck = parseInt(
        window.sessionStorage.getItem(VERSION_CHECK_AT_KEY),
        10,
    );

    if (Number.isFinite(lastCheck) && Date.now() - lastCheck < VERSION_POLL_INTERVAL_MS) {
        cleanReloadTimeParam();
        return;
    }

    window.sessionStorage.setItem(VERSION_CHECK_AT_KEY, String(Date.now()));

    try {
        const response = await fetch(baseUrl + 'php/check_version.php', {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
        });

        if (!response.ok) {
            return;
        }

        const data = await response.json();
        const version = data?.params ?? data?.version;

        if (version != null) {
            applyAppVersion(version);
        }
    } catch {
        cleanReloadTimeParam();
    }
};
